import React, { useRef, useEffect } from 'react';
import Slider from 'react-slick';
import '../styles/LogoCarousel.css';
import { useTranslation } from 'react-i18next';

const logos = [
  { id: 1, src: '/img/companies/Airgas.png', alt: 'Airgas' },
  { id: 2, src: '/img/companies/Hashtag.png', alt: 'Hashtag' },
  { id: 3, src: '/img/companies/Maria-Flor.png', alt: 'Maria Flor' },
  { id: 4, src: '/img/companies/PRESEG.png', alt: 'PRESEG' },
  { id: 5, src: '/img/companies/Thiago.png', alt: 'Thiago' },
  { id: 6, src: '/img/companies/oab-mg.webp', alt: 'OAB' },
  { id: 7, src: '/img/companies/Airgas.png', alt: 'Airgas' },
  { id: 8, src: '/img/companies/Hashtag.png', alt: 'Hashtag' },
  { id: 9, src: '/img/companies/Maria-Flor.png', alt: 'Maria Flor' },
  { id: 10, src: '/img/companies/PRESEG.png', alt: 'PRESEG' },
  { id: 11, src: '/img/companies/Thiago.png', alt: 'Thiago' },
  { id: 12, src: '/img/companies/oab-mg.webp', alt: 'OAB' },
];

const LogoCarousel = ({ isModalOpen }) => {
  const { t } = useTranslation();
  const sliderRef = useRef(null);

  useEffect(() => {
    if (isModalOpen && sliderRef.current) {
      sliderRef.current.slickGoTo(0, true);
      sliderRef.current.slickPlay();
    }
  }, [isModalOpen]);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
      {
        breakpoint: 375,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  return (
    <div className='logo-carousel-container'>
      <h2>{t('partners_title')}</h2>
      <Slider {...settings} ref={sliderRef}>
        {logos.map((logo, index) => (
          <div key={index} className='logo-slide'>
            <div className='logo-box'>
              <img src={logo.src} alt={logo.alt} className='logo-image' />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default LogoCarousel;
